<template>
    <div>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>施工管理</el-breadcrumb-item>
        <el-breadcrumb-item>预约登记</el-breadcrumb-item>
      </el-breadcrumb>
      <el-card>
        <el-row :gutter="0">
          <el-col :span="10">
            <el-input placeholder="请输入查询内容" v-model="queryInfo.query" class="input-with-select" clearable
              style="width:300px " @clear="getyuyueList" @change="getyuyueList">
              <el-button slot="append" icon="el-icon-search" @click="getyuyueList"></el-button>
            </el-input>
          </el-col>
          <el-col :span="4">
            <el-button type="primary" @click="get_yuyue_add" v-if="true">预约登记</el-button>
          </el-col>
          <el-col :span="10" style="text-align: right;">
            <el-button type="primary" @click="handleExport()">导出电子表格</el-button>
          </el-col>
        </el-row>
        <el-row :gutter="0" class="el_row_two" id="report">
          <el-col :span="24">
            <el-table :data="yuyueList" style="width: 100%" border stripe>
              <!-- <el-table-column type="index" label="序号" width="80"></el-table-column> -->
              <el-table-column prop="uid" label=" 序号" width="80"></el-table-column>
              <el-table-column prop="yuyue_bianhao" label="编号" width="200"></el-table-column>
              <el-table-column prop="guest_name" label="客户名称"></el-table-column>
              <el-table-column prop="yuyue_date" label="预约时间"></el-table-column>
              <el-table-column prop="add_time" label="加入时间"></el-table-column>
              <el-table-column label="操作">
                <template v-slot="scope">
                  <el-tooltip class="item" effect="dark" content="修改" placement="top" :enterable="false" v-if="false">
                    <el-button type="primary" icon="el-icon-edit" @click="showEditDialog(scope.row.uid)" circle
                      size="mini"></el-button>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="删除" placement="top" :enterable="false">
                    <el-button type="danger" icon="el-icon-delete" circle size="mini"
                      @click="deleteForm(scope.row.uid)"></el-button>
                  </el-tooltip>
 
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <!-- 分页 -->
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page.sync="queryInfo.pageNum" :page-sizes="[10, 50]" :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total">
          <!--分页组件，其中handleSizeChange 条数下拉触发事件，  handleCurrentChange  选择分页出发事件 currentPage2 当前页绑定 page-sizes 下拉显示列表 page-size 每页多少条绑定 layout 显示分页的元素 total 合计条数绑定  -->
        </el-pagination>
        <!-- 客户回访窗口 -->
        <el-dialog :title="yuyue_title"  :visible.sync="yuyueDialogVisible" width="90%"  @close="addDoalogClosed" >
        <yuyueAdd ref="yuyueAddRef" @over="over" @yuyue_addClose="yuyue_addClose" :key="datekey" >   </yuyueAdd>
      </el-dialog>
      </el-card>
    </div>
  </template>
  <script>
  import { checkMobileTest, checkSfzId } from './config/validator' 
  import exportExcel from './config/exportExcel'
  import yuyueAdd from './module/yuyue_add.vue'
  export default {
    components: {
      yuyueAdd: yuyueAdd 
  },
    data() {
      return {
        yuyue_title: '预约登记',
        datekey: Date.now(),
        // 获取用户列表参数
        queryInfo: {
          C_type: 'get_list',
          C_table_name: 'yuyue_list',
          query: '',
          pageNum: 1,
          pageSize: 10,
          qiye_uid: window.sessionStorage.getItem('qiye_uid')
        },
        yuyueList: [],
        yuyueForm: {
          C_type: 'yuyue_add',
          yuyue_bianhao: '',
          yuyue_title: '',
          yuyue_date: '',
          yuyue_yuangong_uid: 0
        },
        //  recordCount: 0,
        total: 0,
        addDialogVisible: false,
        editDialogVisible: false,
        yuyueDialogVisible: false,
        // 用于修改数据绑定
        editForm: {},
        // 表单规则项
        addFormRules: {
          yuyue_name: [
            { required: true, message: '请输入客户名称', trigger: 'blur' },
            { min: 2, max: 20, message: '必须2到20位字符 ', trigger: 'blur' }
          ],
  
          yuyue_mob: [
            {
              validator: checkMobileTest.bind(
                this.addForm && this.addForm.yuyue_mob
              )
            }
          ],
          yuyue_sfz_bianhao: [
            {
              validator: checkSfzId.bind(
                this.addForm && this.addForm.yuyue_sfz_bianhao
              )
            }
          ]
        },
  
        huifangFormRefRules: {
          huifang_title: [
            { required: true, message: '请输入回访标题', trigger: 'blur' },
            { min: 1, max: 1000, message: '必须1位字符 ', trigger: 'blur' }
          ]
        }
      };
    },
    created() {
      this.getyuyueList() 
    },
    methods: {
      handleExport() {
      exportExcel('report', '导出.xlsx')
    },
      yuyue_addClose() {
        this.yuyueDialogVisible = false
      },
      over() {

      },
      async getXiaoquList() {
        const { data: res } = await this.$http.get('get_api', {
          params: {
            C_type: 'xiaoqu_list_select' // 调用普通api get接口 
          }
        });
        this.xiaoquList = JSON.parse(res.data)[0].dataList
        console.log(this.xiaoquList)
      },
  
      get_switch_value(switchValue) {
        this.huifangForm.huifang_genjin = switchValue ? 1 : 0;
        console.log(this.huifangForm.huifang_genjin);
      },
      async huiFangAdd() {
        const { data: res } = await this.$http.post('api', this.huifangForm);
        console.log(JSON.parse(res.data)[0].bianhao_s);
        this.huifangDialogVisible = true;
      },
      async get_yuyue_add() {
         this.datekey = Date.now()
        // const { data: res } = await this.$http.get('get_api', {
        //   params: { C_type: 'get_bianhao', C_table_type: 20 }
        // });
        // console.log(JSON.parse(res.data)[0].bianhao_l);
        // this.yuyueForm.yuyue_bianhao = JSON.parse(res.data)[0].bianhao_l;
        // // this.total = JSON.parse(res.data)[0].total
        this.yuyueDialogVisible = true;
      },
  
      async getyuyueList() {
        const { data: res } = await this.$http.get('get_api', {
          params: this.queryInfo
        });
        // console.log(JSON.parse(res.data))
        this.yuyueList = JSON.parse(res.data)[0].dataList;
  
        if (!this.yuyueList) return;
        this.yuyueList.forEach(function (item) {
          item.yong_flag = item.yong_flag === 1;
        });
  
        this.total = JSON.parse(res.data)[0].total;
  
        // console.log(this.total)
      },
      //  分页第一项下拉触发
  
      handleSizeChange(newSize) {
        this.queryInfo.pageSize = newSize;
        this.getyuyueList();
      },
      // 选择页数触发
      handleCurrentChange(newPage) {
        this.queryInfo.pageNum = newPage;
        this.getyuyueList();
      },
  
      async addyuyue() {
        this.$refs.addFormRef.validate(async valid => {
          if (!valid) return 1;
          this.add_isDisable = true
          setTimeout(() => {
            this.add_isDisable = false // 点击一次时隔两秒后才能再次点击
          }, 2000)
          const { data: res } = await this.$http.post('api', this.addForm);
          console.log(JSON.parse(res.data)[0].status);
          if (JSON.parse(res.data)[0].status === 201) {
            this.$message.error('手机号码重复')
            return
          } else if ((JSON.parse(res.data)[0].status !== 200) && (JSON.parse(res.data)[0].status !== 201)) {
            this.$message.error('添加失败')
            return
          }
          this.$message.success('添加成功');
          this.getyuyueList();
          this.addDialogVisible = false;
        });
      },
      async addHuifang() {
        this.$refs.huifangFormRef.validate(async valid => {
          if (!valid) return 1;
          this.huifang_isDisable = true
          setTimeout(() => {
            this.huifang_isDisable = false // 点击一次时隔两秒后才能再次点击
          }, 2000)
  
          const { data: res } = await this.$http.post('api', this.huifangForm);
          console.log(JSON.parse(res.data)[0].status);
          if (JSON.parse(res.data)[0].status !== 200) {
            this.$message.error('添加失败');
            return;
          }
          this.$message.success('添加成功');
          this.getyuyueList();
          this.huifangDialogVisible = false;
        });
      },
      showEditDialog(uid) {
        this.yuyueInfo(uid);
        this.editDialogVisible = true;
      },
      addDoalogClosed() {
        // this.$refs.addFormRef.resetFields();
        this.getyuyueList()
      },
      huifangDoalogClosed() {
       //  this.$refs.huifangFormRef.resetFields();
      },
      showHuifangDialog(uid) {
        this.huifangDialogVisible = true;
        this.yuyueInfo(uid);
      },
      editDoalogClosed() {
        this.$refs.editFormRef.resetFields();
      },
      async yuyueInfo(uid) {
        const { data: res } = await this.$http.get('get_api', {
          params: { C_table_name: 'yuyue_info', uid: uid, C_type: 'get_info' }
        });
        // console.log(JSON.parse(res.data))
        console.log(res.data);
        if (JSON.parse(res.data)[0].status !== 200) {
          return this.$message.error('读取失败');
        }
  
        this.editForm = JSON.parse(res.data)[0].data[0];
        this.huifangForm.huifang_yuyue_uid = JSON.parse(res.data)[0].data[0].uid;
      },
      async updateyuyue() {
        this.$refs.editFormRef.validate(async valid => {
          if (!valid) return this.$message.error('验证错误！');
          this.editForm.C_type = 'yuyue_update';
          // 对象加入一个项C_type
          const { data: res } = await this.$http.post('api', {
            C_type: 'yuyue_update',
            yuyue_bianhao: this.editForm.yuyue_bianhao.trim(),
            yuyue_name: this.editForm.yuyue_name,
            yuyue_mob: this.editForm.yuyue_mob,
            yuyue_addr: this.editForm.yuyue_addr,
            yuyue_sfz_bianhao: this.editForm.yuyue_sfz_bianhao,
            yuyue_level: this.editForm.yuyue_level,
            yuyue_price_want: this.editForm.yuyue_price_want,
            yuyue_yixiang: this.editForm.yuyue_yixiang,
            yuyue_memo: this.editForm.yuyue_memo,
            yuyue_laiyuan: this.editForm.yuyue_laiyuan,
            yuyue_uid: this.editForm.uid,
            xiaoqu_uid: this.editForm.xiaoqu_uid
          });
  
          if (JSON.parse(res.data)[0].status !== 200) {
            this.$message.error('更新失败');
            return;
          }
          this.$message.success('更新成功');
          this.getyuyueList();
          this.editDialogVisible = false;
        });
      },
      async deleteForm(yuyueUid) {
        // 此处通过异步获取操作行为，而不用then ，来避免异步嵌套
        // 异步操作有2个，1个对话框等待，1个是网络请求
        const comfirmResult = await this.$confirm(
          '确定删除该条记录, 是否继续?',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        ).catch(err => err);
        console.log(comfirmResult);
        if (comfirmResult === 'cancel') return this.$message.info('已经取消删除');
        const { data: res } = await this.$http.post('api', {
          C_type: 'record_delete',
          C_table_name: 'yuyue_del',
          C_data1: yuyueUid
        });
        if (JSON.parse(res.data)[0].status !== 200) {
          this.$message.error('删除失败');
          return;
        }
        this.$message.success('删除成功');
        this.getyuyueList();
      },
  
      // 设置白名单
      async baiMingdan(yuyueUid, baiMingdanFlag) {
        // 此处通过异步获取操作行为，而不用then ，来避免异步嵌套
        // 异步操作有2个，1个对话框等待，1个是网络请求
        const comfirmResult = await this.$confirm(
          '确定要设置为白名单吗, 是否继续?',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        ).catch(err => err);
        console.log(comfirmResult);
        if (comfirmResult === 'cancel') return this.$message.info('已经取消删除');
        const { data: res } = await this.$http.post('api', {
          C_type: 'yuyue_baiMingdan',
          yuyueUid: yuyueUid,
          baiMingdan_flag: !baiMingdanFlag
        });
        if (JSON.parse(res.data)[0].status !== 200) {
          this.$message.error('设置失败');
          return;
        }
        this.$message.success('设置成功');
        this.getyuyueList();
      }
    }
  };
  </script>
  <style lang="less" scoped>
  .card_two {
    margin-top: 30px;
    box-shadow: none !important;
    background-color: #f2f6fc;
  }
  
  .el_row_two {
    margin-top: 30px;
  }
  </style>
